export const removeUnderline = (text: string) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1).replace("_", " ") : null;
